/*
  src/redux/auth/reducer.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import update from 'immutability-helper';

import {
  TOKEN_LOADED_FROM_COOKIE,
  TOKEN_LOADED,
  TOKEN_REQUESTED,
  TOKEN_FAILED_TO_LOAD,
  TOKEN_INVALIDATED
} from './constants';

const initialState = {
  token:null,
  error:null,
  email:null
};

export default function(state=initialState,action){
  if(action.error && action.payload.name === 'AuthenticationError'){}

  switch(action.type){
  case TOKEN_LOADED_FROM_COOKIE:
    return update(state,{
      $merge:{
        token: action.payload.token,
        email: action.payload.email
      }
    });

  case TOKEN_LOADED:
    return update(state,{
      token:{
        $set: action.payload
      }
    });

  case TOKEN_REQUESTED:
    return update(state,{
      email:{
        $set: action.payload
      }
    });

  case TOKEN_FAILED_TO_LOAD:
    return update(state,{
      $merge:{
        error: action.payload,
        token: null,
        email: null
      }
    });

  case TOKEN_INVALIDATED:
    return update(state,{
      $merge:{
        token: null,
        email: null
      }
    });

  default:
    return update(state,{});
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/auth/reducer.js